import { useQuery } from '@tanstack/react-query';
import { getClubesByNombre } from '../../services/clubesService';

/**
 * Hook para buscar clubes por nombre
 * @param {string} nombre - Nombre o parte del nombre del club
 * @param {object} options - Opciones de React Query
 */
export const useClubes = (nombre = '', options = {}) => {
  return useQuery({
    queryKey: ['clubes', nombre],
    queryFn: () => getClubesByNombre(nombre, null),
    enabled: nombre.length > 0,
    staleTime: 30 * 60 * 1000, // 30 minutos
    ...options,
  });
};

/**
 * Hook alias para buscar club específico (mismo que useClubes pero más específico)
 * @param {string} nombre - Nombre del club
 * @param {object} options - Opciones de React Query
 */
export const useClubById = (nombre, options = {}) => {
  return useClubes(nombre, options);
};

export { useClubes as default };
